export * from './LazySvg';
